import React, { FC } from 'react';
import { FieldError } from 'react-hook-form';
import Alert from 'react-bootstrap/Alert';
import { FaExclamationCircle } from 'react-icons/fa';

interface IFormErrorsProps {
  errors: FieldError;
  onClose?: () => void;
}

/*
 * Abstracted errors component, displaying common FORM errors.
 * It serves different layout based on props.
 */
const FormErrors: FC<IFormErrorsProps> = ({ errors, onClose }) => {
  return (
    <Alert
      variant="danger"
      onClose={onClose}
      dismissible
    >
      <FaExclamationCircle
        size={15}
        style={{ marginRight: 6, display: 'inline' }}
      />
      <p className="mb-0 d-inline">{errors.message}</p>
    </Alert>
  );
};

export default FormErrors;
